const appExcepMessage = 'com.vertrax.wellsite.common.exception.ApplicationException';
const appCustomExcepMessage = 'com.vertrax.wellsite.common.exception.CustomException';
const appSQLException = 'com.microsoft.sqlserver.jdbc.SQLServerException';
const appGeotabException = 'com.vertrax.geotab.exception.GeotabException';
const appNullPointerException = 'java.lang.NullPointerException';
const eldException = 'com.vertrax.eld.exception.EldException';
const accountException = 'javax.security.auth.login.AccountException';

interface IResponse {
  class: string;
  message: string;
  stackTraceList: string[];
}

export class CustomExceptions {
  response: IResponse;
  constructor(response: IResponse) {
    this.response = response;
  }
  getCustomMessage() {
    const defaultError = 'An error occurred on the server';
    let error = '';
    if (
      this.response &&
      this.response.hasOwnProperty('class') &&
      this.response.class === appCustomExcepMessage &&
      this.response.hasOwnProperty('message')
    ) {
      try {
        const message = this.response.message;
        if (message.includes(appExcepMessage)) {
          const split = splitFirstOcurrence(message, `${appExcepMessage}:`);
          const obj = isJSON(split) ? JSON.parse(split.trimStart().trimEnd()) : this.response;

          if (obj.hasOwnProperty('class') && obj.class === appCustomExcepMessage && obj.hasOwnProperty('message')) {
            error = obj.message;
          }
          if (error.includes(accountException) || error.includes(appExcepMessage)) {
            const delimiter = error.includes(accountException) ? accountException : appExcepMessage;
            const split = error.split(`${delimiter}:`);
            const msg = split[1].trimStart().trimEnd();
            error = msg;
          }
        } else {
          const filterMessage = this.filterMessage(message);
          if (filterMessage) {
            error = filterMessage.trimStart().trimEnd();
            if (error.includes(appNullPointerException)) {
              error = defaultError;
            }
          }
        }
      } catch (e) {
        console.log(e);
      }
    }
    return error ? this.replaceUnicode(error) : defaultError;
  }

  filterMessage = (message: string): string => {
    return message
      .replace(`${appExcepMessage}:`, '')
      .replace(`${appSQLException}:`, '')
      .replace(`${appGeotabException}:`, '')
      .replace(`${eldException}:`, '');
  };

  replaceUnicode = (message: string) => {
    return message.replace(/\\u[a-zA-Z0-9]{4}/g, '');
  };
}

function splitFirstOcurrence(value: string, delimiter: string) {
  if (!value) return '';

  const substrings = value.split(delimiter);
  return substrings.length === 1 ? value : substrings.slice(1).join(delimiter);
}

function isJSON(value: string) {
  if (typeof value !== 'string') {
    return false;
  }
  try {
    JSON.parse(value);
    return true;
  } catch (error) {
    return false;
  }
}

export const arrayErrorsExcludedText = ['Unable to assign load historically'];
